// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/exportdata/v1/exportdata.proto" (package "c1.api.exportdata.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ExportDataService } from "./exportdata";
import type { ListExportDataResponse } from "./exportdata";
import type { ListExportDataRequest } from "./exportdata";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ExportDataResponse } from "./exportdata";
import type { ExportDataRequest } from "./exportdata";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.exportdata.v1.ExportDataService
 */
export interface IExportDataServiceClient {
    /**
     * @generated from protobuf rpc: ExportData(c1.api.exportdata.v1.ExportDataRequest) returns (c1.api.exportdata.v1.ExportDataResponse);
     */
    exportData(input: ExportDataRequest, options?: RpcOptions): UnaryCall<ExportDataRequest, ExportDataResponse>;
    /**
     * @generated from protobuf rpc: List(c1.api.exportdata.v1.ListExportDataRequest) returns (c1.api.exportdata.v1.ListExportDataResponse);
     */
    list(input: ListExportDataRequest, options?: RpcOptions): UnaryCall<ListExportDataRequest, ListExportDataResponse>;
}
/**
 * @generated from protobuf service c1.api.exportdata.v1.ExportDataService
 */
export class ExportDataServiceClient implements IExportDataServiceClient, ServiceInfo {
    typeName = ExportDataService.typeName;
    methods = ExportDataService.methods;
    options = ExportDataService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ExportData(c1.api.exportdata.v1.ExportDataRequest) returns (c1.api.exportdata.v1.ExportDataResponse);
     */
    exportData(input: ExportDataRequest, options?: RpcOptions): UnaryCall<ExportDataRequest, ExportDataResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExportDataRequest, ExportDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List(c1.api.exportdata.v1.ListExportDataRequest) returns (c1.api.exportdata.v1.ListExportDataResponse);
     */
    list(input: ListExportDataRequest, options?: RpcOptions): UnaryCall<ListExportDataRequest, ListExportDataResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExportDataRequest, ListExportDataResponse>("unary", this._transport, method, opt, input);
    }
}
